export const Constants = {
    notice: {
        numberOfDatesForNewPosts: 7,
    },
    otherUrl: {
        certiLifeUrl: 'https://certi.life',
        certiLifeUrlWithContact: 'https://certi.life/#contact',
        dashboardGuideUrl: 'https://certilife.oopy.io',
        bulkIssueGuideUrl: 'https://drive.google.com/file/d/1D7G-DUTMB3aIbA9qlrfGFboLj-LJ9XU1/view',
        bulkIssueGuideDownloadUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/web_asset%252FCertiLife-ZEISS-%25EB%258C%2580%25EB%259F%2589%25EB%25B0%259C%25ED%2596%2589-%25EB%25A7%25A4%25EB%2589%25B4%25EC%2596%25BC_2023-10-30.pdf',
        bulkIssueGuideDownloadFileName: 'CertiLife-ZEISS-대량발행-매뉴얼_2023-10-30',
        googleSheetsUrl: 'https://www.google.com/intl/ko_kr/sheets/about/',
    },
    storeUrl: {
        playStoreUrl: 'https://play.google.com/store/apps/details?id=com.certilife.hospital&hl=ko-KR',
        appStoreUrl: 'https://apps.apple.com/kr/app/%EC%84%9C%ED%8B%B0%EB%9D%BC%EC%9D%B4%ED%94%84-%EB%B3%91%EC%9B%90%EC%9A%A9/id6450404968',
    },
    policiesUrl: {
        privacyPolicyUrl: 'https://abiding-door-957.notion.site/0647135c47d04de2844de58355347112?pvs=4',
        termsOfUseUrl: 'https://abiding-door-957.notion.site/202d8c6235ed40e58b60fe571f689731',
    },
    // 병원 회원가입 동의 항목 URL (로그인/비밀번호 설정 페이지의 policiesUrl과 별도 관리)
    signupPoliciesUrl: {
        termsOfUseUrl: 'https://abiding-door-957.notion.site/2025-07-2338672510d0800d818cf3d1ca7e7ba7',
        privacyPolicyUrl: 'https://abiding-door-957.notion.site/2026-04-2958672510d08077b995f8e47a076aaf',
        marketingConsentUrl: 'https://abiding-door-957.notion.site/2025-07-23e8672510d080c4a485d59b7be18020',
    },
    pagination: {
        pageListSizeForMobile: 5,
        pageListSizeForDesktop: 10,
    },
    defaultNftInfo: {
        defaultImageUrl: 'https://certilife.blob.core.windows.net/certilife/project_hardcoding_files/v1/ccafc24ca12c46ebbbabd8b194911349/certilife/nft_card%252FPreview_title_only.png',
        defaultColorCode: '#C7CCD1',
    },
    miscText: {
        appDownloadText: 'CertiLife 앱을 다운로드 받으세요!',
    }
}